"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemAttributeSettingSchema = exports.ItemAttributeSchema = exports.ItemAttributeSettingDefinitionSchema = exports.AttributeSettingSchema = exports.ItemAttributeChannelAssociationSchema = exports.ItemAttributeAllowedValueSchema = exports.ItemAttributeValueAssociationSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.ItemAttributeValueAssociationSchema = zod_1.z.object({
    attributeId: zod_1.z.string(),
    valueId: zod_1.z.string(),
});
exports.ItemAttributeAllowedValueSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    value: zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean()]),
    dependsOn: zod_1.z.array(exports.ItemAttributeValueAssociationSchema),
});
exports.ItemAttributeChannelAssociationSchema = zod_1.z.object({
    associatedChannel: __1.ChannelSchema,
    channelAttributeId: zod_1.z.string(),
    channelAdditionalData: zod_1.z.record(zod_1.z.object({})).optional(),
});
exports.AttributeSettingSchema = zod_1.z.object({
    editableWithSales: zod_1.z.boolean().optional(),
});
exports.ItemAttributeSettingDefinitionSchema = zod_1.z.object({
    attributePath: zod_1.z.string(),
    settings: exports.AttributeSettingSchema,
});
exports.ItemAttributeSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    channelAttributeId: zod_1.z.string(),
    channelValueId: zod_1.z.string().optional(),
    channelValueName: zod_1.z.string().optional(),
});
exports.ItemAttributeSettingSchema = __1.BaseSchema.extend({
    allowedValues: zod_1.z.array(exports.ItemAttributeAllowedValueSchema).optional(),
    channelAssociation: zod_1.z.record(exports.ItemAttributeChannelAssociationSchema),
    defaultValue: exports.ItemAttributeAllowedValueSchema.optional(),
    hint: zod_1.z.string().optional(),
    isHidden: zod_1.z.boolean().optional(),
    isRequired: zod_1.z.boolean().optional(),
    isVariationAttribute: zod_1.z.boolean().optional(),
    allowVariations: zod_1.z.boolean().optional(),
    isGridFilter: zod_1.z.boolean().optional(),
    name: zod_1.z.string(),
    valueMaxLength: zod_1.z.number().optional(),
    valueMinLength: zod_1.z.number().optional(),
    maxValue: zod_1.z.number().optional(),
    minValue: zod_1.z.number().optional(),
    valueType: zod_1.z.nativeEnum(__1.ItemAttributeValueType),
    dependsOn: zod_1.z.array(exports.ItemAttributeValueAssociationSchema).optional(),
});
//# sourceMappingURL=item-attribute.js.map